import { Box, Typography } from '@mui/material';
import PropTypes from 'prop-types';
import { Doughnut } from 'react-chartjs-2';
import ChartTooltip from './Charts/ChartTooltip';

const KpiWithInfo = ({ data, options, title, infoText, classes }) => {
  if (!data || data.labels.length === 0) {
    return null;
  }

  return (
    <Box sx={{ position: 'relative', my: 4 }}>
      <Typography className={classes.chartRef}>{title}</Typography>
      <Doughnut data={data} options={options} redraw />
      {infoText && <ChartTooltip infoText={infoText} styleMarginTop={8} />}
    </Box>
  );
};

KpiWithInfo.propTypes = {
  data: PropTypes.object.isRequired,
  options: PropTypes.object,
  title: PropTypes.string,
  infoText: PropTypes.string,
  classes: PropTypes.object,
};

export default KpiWithInfo;
